import { DashboardSettingsFilters } from "../../../__generated__/api";
import Registry from "../../../base-registry";
import { Ticket } from "../../../pages/tickets-v3/TicketsV3";
import TicketItem from "../ticket-item";

export class Filter {
    public constructor(protected readonly filter: DashboardSettingsFilters) {
        // do nothing
    }

    // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
    public shouldInclude(_ticket: TicketItem): boolean {
        return false;
    }

    // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
    public shouldIncludeTicket(_ticket: Ticket): boolean {
        return false;
    }
}

interface FilterCreator {
    shouldCreate(filter: DashboardSettingsFilters): boolean;
}

export const FILTER_REGISTRY = new Registry<typeof Filter & FilterCreator>();
